<mat-sidenav-container class="sidenav-container" [hasBackdrop]="true">
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
    [attr.role]="'dialog'"
    [mode]="'over'"
    [opened]="">
  <mat-toolbar>Menu</mat-toolbar>
  <mat-nav-list>
    <a mat-list-item routerLink="/sensors"(click)="drawer.toggle()">Sensors</a>
    <a mat-list-item routerLink="/inspect">Inspect</a>
    <a mat-list-item href="#">Home</a>
  </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
  <mat-toolbar color="primary">
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="drawer.toggle()"
      *ngIf="true">
      <mat-icon aria-label="Side nav toggle icon" *ngIf="!drawer.opened; else showCross">
        menu
      </mat-icon>
      <ng-template #showCross>
        <mat-icon aria-label="Side nav toggle icon">close</mat-icon>
      </ng-template>
    </button>
    <span>Liquid Prep</span>
  </mat-toolbar>
  
  
  </mat-sidenav-content>
  </mat-sidenav-container>
  
  <ng-content>
  </ng-content>
  <router-outlet></router-outlet>
